<section class="section grey-900" *ngIf="globalReachPanelData">
  <div class="section-container">
    <div class="section-go-global">
      <div class="go-global-blog white-100">
        <div class="go-global-content">
          <div class="product-blog-subheading mar-b-16">
            {{ globalReachPanelData.component1[0].fields.tags.fields.tagName }}
          </div>
          <div class="product-blog-heading mar-b-16">
            {{
              globalReachPanelData.component1[0].fields.richTextTitle.content[0]
                .content[0].value
            }}
          </div>
          <p class="product-blog-description wid-75">
            {{
              globalReachPanelData.component1[0].fields.description.content[0]
                .content[0].value
            }}
          </p>
        </div>
        <figure class="go-global-img">
          <img
            loading="lazy"
            [src]="
              globalReachPanelData.component1[0].fields.imageicon.fields.file
                .url
            "
            class="wid-full"
            alt=""
          />
        </figure>
      </div>
      <div class="go-global-blog white-100 padd-48">
        <div>
          <div class="product-blog-subheading mar-b-16">
            {{ globalReachPanelData.component1[1].fields.tags.fields.tagName }}
          </div>
          <div class="product-blog-heading mar-b-16">
            {{
              globalReachPanelData.component1[1].fields.richTextTitle.content[0]
                .content[0].value
            }}
          </div>
          <p class="product-blog-description">
            {{
              globalReachPanelData.component1[1].fields.description.content[0]
                .content[0].value
            }}
          </p>
        </div>
        <figure>
          <img
            loading="lazy"
            [src]="
              globalReachPanelData.component1[1].fields.imageicon.fields.file
                .url
            "
            class="wid-full"
            alt=""
          />
        </figure>
      </div>
    </div>
    <div class="landing-btn mar-t-48 justfy-c align-c">
      <a
        href="{{ globalReachPanelData?.component1[0]?.fields.button[0].fields.redirectLink | urlParams:queryParams}}"
        class="btn btn-full"
        (click)="onGlobalReachCTAClick()"
      >
        {{
          globalReachPanelData?.component1[0]?.fields.button[0].fields
            .buttonText
        }}
      </a>
    </div>
  </div>
</section>
